var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowStickLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.394 165.658C202.736 157.666 189.24 158.206 181.248 166.863L112.325 241.529C104.782 249.701 104.781 262.297 112.325 270.469L181.248 345.137C189.239 353.794 202.736 354.334 211.394 346.343C220.051 338.351 220.591 324.854 212.6 316.197L176.725 277.333L384.001 277.333C395.783 277.333 405.334 267.781 405.334 255.999C405.334 244.217 395.783 234.666 384.001 234.666L176.726 234.666L212.6 195.804C220.591 187.146 220.051 173.649 211.394 165.658Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowStickLeft);
export default __webpack_public_path__ + "static/media/arrow-stick-left.a94eb968d9a831a539cb311c20e079d3.svg";
export { ForwardRef as ReactComponent };